import { BackrsIcon, BackrsIcons } from '@backrs_ui/common-ui';

import { Box, FormControlLabel, Radio, Typography, SxProps, Theme } from '@mui/material';

type ProficiencyLevelRadioGroupProps = Readonly<{
  value: number;
  content: {
    title: string;
    description: string;
    icon: BackrsIcons;
    iconAlt: string;
  };
}>;

export const ProficiencyLevelRadioGroup = ({ value, content }: ProficiencyLevelRadioGroupProps) => {
  return (
    <Box sx={radioGroupStyles}>
      <FormControlLabel
        value={value}
        control={<Radio sx={radioSx} />}
        label={
          <Box sx={labelAndIconContainerStyles}>
            <Box sx={iconContainerStyles}>
              <BackrsIcon name={content.icon} alt={content.iconAlt} />
              {content.title}
            </Box>
            <Typography sx={largeScreenDescriptionStyles}>{content.description}</Typography>
          </Box>
        }
        sx={formControlLabelStyles}
      />
      <Typography sx={smallScreenDescriptionStyles}>{content.description}</Typography>
    </Box>
  );
};

const radioSx: SxProps<Theme> = ({ backrs }) => ({
  '& .MuiSvgIcon-root': {
    width: '24px',
    height: '24px',
  },
  '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)': {
    color: 'inherit',
    backgroundColor: backrs.colors['Colors/Base/Transparent'],
    border: 'none',
    '& path': {
      fill: 'currentColor',
    },
  },
  '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
    color: 'inherit',
    margin: 0,
    opacity: 0,
  },
  '&.Mui-checked .MuiSvgIcon-root + .MuiSvgIcon-root': {
    opacity: 1,
  },
});

const radioGroupStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  gap: 2,
  '@media (max-width: 600px)': {
    flexDirection: 'column',
    pb: 4,
  },
};

const formControlLabelStyles: SxProps<Theme> = {
  flex: 1,
  outline: 'none',
  padding: 0,
  alignItems: 'center',
};

const labelAndIconContainerStyles: SxProps<Theme> = {
  flexDirection: 'row',
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  '@media (max-width: 600px)': {
    fontSize: '20px',
  },
};

const iconContainerStyles: SxProps<Theme> = {
  flexDirection: 'column',
  display: 'flex',
  alignItems: 'center',
  ml: 3,
  '@media (max-width: 600px)': {
    flexDirection: 'row',
    gap: 4,
  },
};

const smallScreenDescriptionStyles: SxProps<Theme> = {
  display: 'none',
  '@media (max-width: 600px)': {
    display: 'block',
  },
};

const largeScreenDescriptionStyles: SxProps<Theme> = {
  ml: 3,
  '@media (max-width: 600px)': {
    display: 'none',
  },
};
